module.exports = __webpack_public_path__ + "img/1.7593e206.png";